<template>
  <div class="vue_body_min_height">
    <div id="intro_top_img" v-if="currentBanner != null">
      <img :src="currentBanner.url">
    </div>

    <div id="sub_menu_outer">
      <div id="sub_menu_content">
        <a :href="currentMenuItem.src + '/' + subList[index].id"
           v-for="(item, index) in tabList"
           :key="'intro_sub_menu_tab_' + index"
           :class="[index == currentIndex ? 'active' : '']"
        >
          <img :src="index == currentIndex ? item.selected : item.normal">
        </a>
      </div>
    </div>

    <div class="container" id="intro_content_outer">
      <div id="intro_content">
        <profile-detail v-show="currentIndex == 0" />
        <organization-detail v-show="currentIndex == 1" />
        <member-vue v-show="currentIndex == 2" />
        <contact-us-detail v-show="currentIndex == 3" />
      </div>
    </div>
  </div>
</template>

<script>
import ContactNormalImage from '../assets/shl_introduce_tab_contact_normal.png';
import ContactSelectedImage from '../assets/shl_introduce_tab_contact_selected.png';
import ProfileNormalImage from '../assets/shl_introduce_tab_profile_normal.png';
import ProfileSelectedImage from '../assets/shl_introduce_tab_profile_selected.png';
import OrganizetNormalImage from '../assets/shl_introduce_tab_organize_normal.png';
import OrganizeSelectedImage from '../assets/shl_introduce_tab_organize_selected.png';
import MemberNormalImage from '../assets/shl_introduce_tab_member_normal.png';
import MemberSelectedImage from '../assets/shl_introduce_tab_member_selected.png';

import GlobalInstance from '../js/shba'
import ProfileDetail from "../components/introduce/ProfileDetail";
import MemberVue from "../components/introduce/Member";
import ContactUsDetail from "../components/introduce/ContactUsDetail";
import OrganizationDetail from "../components/introduce/OrganizationDetail";

export default {
  name: "IntroducePage",
  components: {ContactUsDetail, MemberVue, OrganizationDetail, ProfileDetail},
  data() {
    return {
      title: '走近篮协',

      tabList: [
        {
          title: '协会简介',
          normal: ProfileNormalImage,
          selected: ProfileSelectedImage
        },
        {
          title: '组织架构',
          normal: OrganizetNormalImage,
          selected: OrganizeSelectedImage
        },
        {
          title: '协会会员',
          normal: MemberNormalImage,
          selected: MemberSelectedImage
        },
        {
          title: '联系我们',
          normal: ContactNormalImage,
          selected: ContactSelectedImage
        },
      ],
    }
  },
  computed: {
    banners() {
      return this.$store.state.banners;
    },
    currentBanner() {
      if (this.banners == null) {
        return null;
      }
      let item = this.banners.find(function (item) {
        return  item.name == 'introduce';
      });

      if (item == undefined) {
        return null;
      }
      return item;
    },
    introduceData() {
      return this.$store.state.introduceData;
    },

    subList() {
      return GlobalInstance.methods.subMenuLlist(this.$route);
    },
    currentIndex() {
      let index = GlobalInstance.methods.subTabIndex(this.$route);
      return index >=0 ? index : 0;
    },
    currentMenuItem() {
      return GlobalInstance.methods.currentMenuItem(this.$route);
    }
  },
  mounted() {
    if (this.introduceData == null) {
      this.loadData();
    }
    let shareObj = this.$store.state.http.defaultShareObj;
    shareObj.title = '走近篮协 —— ' + this.tabList[this.currentIndex].title;
    shareObj.link = location.href;
    this.configShareWx(encodeURIComponent(location.href), shareObj);
  },
  methods: {
    loadData() {
      let _this = this;
      this.$store.state.http.ajax.vmAbout(function (data) {
        // console.log(data);
        if (data.code == 0) {
          _this.$store.commit('setIntroduce', data.data);
        }
      }, function (data) {

      })
    },
  },
}
</script>

<style scoped>

  #intro_top_img {
    width: 100%;
    text-align: center;
    background-color: #fc1a34;
    padding: 0;
  }

  #intro_top_img > img {
    width: 100%;
    height: auto;
  }

  #sub_menu_outer {
    width: 100%;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: center;
    padding-top: 5vh;
    padding-bottom: 5vh;
  }

  #sub_menu_content {
    width: 90%;
    max-width: 1200px;
    min-width: 290px;
    flex-wrap: nowrap;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-around;
  }

  #sub_menu_content img {
    max-width: 130px;
    min-width: 60px;
    width: 6vw;
  }

  #sub_menu_content > a.active {
    pointer-events: none;
  }

  #intro_content_outer {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: center;
    margin-bottom: 80px;
  }

  #intro_content {
    width: 100%;
    box-shadow: 0 0 15px rgba(255,0,0, 0.15);
    padding: 30px 30px;
  }


</style>



// WEBPACK FOOTER //
// src/pages/IntroducePage.vue